// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.all-farm-tab-coachmark-tooltip {
  /* tooltip */
  box-sizing: border-box;
  position: fixed;
  z-index: 1200;
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2px 0px 0px;
  isolation: isolate;
  width: 256px;
  height: 94px;
  filter: drop-shadow(0px 3px 6px rgba(28, 29, 32, 0.3));
}

.all-farm-tab-coachmark-tooltip__pointer {
  /* pointer */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0px 8px;
  width: 256px;
  height: 15px;
  margin: -3px 0px;
  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  z-index: 1;
}

.all-farm-tab-coachmark-tooltip__triangle {
  /* triangle */
  box-sizing: border-box;
  width: 20px;
  height: 14px;
  background: var(--color-data-data);
  background: var(--color-data-data);
  border: 1px solid var(--color-data-data);
  border: 1px solid var(--color-data-data);
  /* Start as a "down" triangle; rotate -180deg makes it point up (as in Figma). */
  clip-path: polygon(50% 100%, 0% 0%, 100% 0%);
  flex: none;
  order: 0;
  flex-grow: 0;
  margin: -1px 0px;
  transform: rotate(-180deg);
  transform-origin: 50% 50%;
}

.all-farm-tab-coachmark-tooltip__concealer {
  /* concealer */
  width: 240px;
  height: 2px;
  background: var(--color-data-data);
  background: var(--color-data-data);
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
}

.all-farm-tab-coachmark-tooltip__body {
  /* body */
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 8px;
  width: 256px;
  max-width: 320px;
  height: 80px;
  background: var(--color-data-data);
  background: var(--color-data-data);
  border: 1px solid var(--color-data-data);
  border: 1px solid var(--color-data-data);
  border-radius: 8px;
  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  z-index: 0;
}

.all-farm-tab-coachmark-tooltip__message-container {
  /* new section message */
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 8px;
  gap: 8px;
  width: 240px;
  height: 64px;
  flex: none;
  order: 0;
  flex-grow: 1;
}

.all-farm-tab-coachmark-tooltip__message-text {
  width: 224px;
  height: 48px;
  color: var(--color-grey-100);
  color: var(--color-grey-100);
  line-height: 16px;
  text-align: center;
  letter-spacing: 0.01em;
  white-space: pre-line;
  flex: none;
  order: 0;
  flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./app/components/general/AllFarmTabCoachmark.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,aAAa;EACb,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;EACxC,gFAAgF;EAChF,4CAA4C;EAC5C,UAAU;EACV,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,kCAAkC;EAClC,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,kCAAkC;EAClC,kCAAkC;EAClC,wCAAwC;EACxC,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,QAAQ;EACR,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,4BAA4B;EAC5B,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,qBAAqB;EACrB,UAAU;EACV,QAAQ;EACR,YAAY;AACd","sourcesContent":[".all-farm-tab-coachmark-tooltip {\n  /* tooltip */\n  box-sizing: border-box;\n  position: fixed;\n  z-index: 1200;\n  transform: translateX(-50%);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2px 0px 0px;\n  isolation: isolate;\n  width: 256px;\n  height: 94px;\n  filter: drop-shadow(0px 3px 6px rgba(28, 29, 32, 0.3));\n}\n\n.all-farm-tab-coachmark-tooltip__pointer {\n  /* pointer */\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 0px 8px;\n  width: 256px;\n  height: 15px;\n  margin: -3px 0px;\n  flex: none;\n  order: 0;\n  align-self: stretch;\n  flex-grow: 0;\n  z-index: 1;\n}\n\n.all-farm-tab-coachmark-tooltip__triangle {\n  /* triangle */\n  box-sizing: border-box;\n  width: 20px;\n  height: 14px;\n  background: var(--color-data-data);\n  background: var(--color-data-data);\n  border: 1px solid var(--color-data-data);\n  border: 1px solid var(--color-data-data);\n  /* Start as a \"down\" triangle; rotate -180deg makes it point up (as in Figma). */\n  clip-path: polygon(50% 100%, 0% 0%, 100% 0%);\n  flex: none;\n  order: 0;\n  flex-grow: 0;\n  margin: -1px 0px;\n  transform: rotate(-180deg);\n  transform-origin: 50% 50%;\n}\n\n.all-farm-tab-coachmark-tooltip__concealer {\n  /* concealer */\n  width: 240px;\n  height: 2px;\n  background: var(--color-data-data);\n  background: var(--color-data-data);\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n}\n\n.all-farm-tab-coachmark-tooltip__body {\n  /* body */\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  padding: 8px;\n  width: 256px;\n  max-width: 320px;\n  height: 80px;\n  background: var(--color-data-data);\n  background: var(--color-data-data);\n  border: 1px solid var(--color-data-data);\n  border: 1px solid var(--color-data-data);\n  border-radius: 8px;\n  flex: none;\n  order: 1;\n  align-self: stretch;\n  flex-grow: 0;\n  z-index: 0;\n}\n\n.all-farm-tab-coachmark-tooltip__message-container {\n  /* new section message */\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 8px;\n  gap: 8px;\n  width: 240px;\n  height: 64px;\n  flex: none;\n  order: 0;\n  flex-grow: 1;\n}\n\n.all-farm-tab-coachmark-tooltip__message-text {\n  width: 224px;\n  height: 48px;\n  color: var(--color-grey-100);\n  color: var(--color-grey-100);\n  line-height: 16px;\n  text-align: center;\n  letter-spacing: 0.01em;\n  white-space: pre-line;\n  flex: none;\n  order: 0;\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
